/**
 * UTM Parameters Utility
 * 
 * Captures UTM parameters from the URL query string, stores them in sessionStorage,
 * and provides helpers to retrieve them for use in forms.
 * 
 * Supported UTM params: utm_source, utm_medium, utm_campaign, utm_term, utm_content, utm_id
 */

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id']
const SESSION_STORAGE_KEY = 'hmz_utm_params'

/**
 * Capture UTM parameters from the current URL and store them in sessionStorage.
 * Only stores if at least one UTM param is present in the URL.
 * Does NOT overwrite previously stored params (first-touch attribution).
 */
export function captureUtmParams() {
  const searchParams = new URLSearchParams(window.location.search)
  const utmParams = {}
  let hasUtm = false

  UTM_KEYS.forEach(key => {
    const value = searchParams.get(key)
    if (value) {
      utmParams[key] = value
      hasUtm = true
    }
  })

  if (hasUtm) {
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(utmParams))
    } catch (e) {
      console.warn('Failed to store UTM params in sessionStorage:', e)
    }
  }
}

/**
 * Retrieve stored UTM parameters from sessionStorage.
 * @returns {Object} An object with UTM key-value pairs, or empty object if none stored.
 */
export function getUtmParams() {
  try {
    const stored = sessionStorage.getItem(SESSION_STORAGE_KEY)
    if (stored) {
      return JSON.parse(stored)
    }
  } catch (e) {
    console.warn('Failed to read UTM params from sessionStorage:', e)
  }
  return {}
}

